import React from "react";
import Layout from "./Layout";
import GoleadoresSection from "../sections/GoleadoresSection";

const Goleadores = () => {
  return (
    <>
      <Layout>
        <GoleadoresSection />
      </Layout>
    </>
  );
};

export default Goleadores;
